import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSettings, updateSettings } from "../features/settings/settingsSlice";
import {
  getSchemeNames,
  updateSchemeNames,
} from "../features/goldScheme/goldSchemeSlice";
import { toast } from "react-toastify";

const GeneralSettings = () => {
  const dispatch = useDispatch();
  const { settings, isLoading } = useSelector((state) => state.settings);
  const { schemeNames } = useSelector((state) => state.goldScheme);
  const [showPrice, setShowPrice] = useState(true);
  const [newSchemeName, setNewSchemeName] = useState("");
  const [localSchemeNames, setLocalSchemeNames] = useState([]);

  useEffect(() => {
    dispatch(getSettings());
    dispatch(getSchemeNames());
  }, [dispatch]);

  useEffect(() => {
    if (settings && settings.length > 0) {
      const showPriceSetting = settings.find((s) => s.name === "show_price");
      if (showPriceSetting) {
        setShowPrice(showPriceSetting.value === "true");
      }
    }
  }, [settings]);

  useEffect(() => {
    setLocalSchemeNames(schemeNames || []);
  }, [schemeNames]);

  const handleToggle = (value) => {
    setShowPrice(value);
    const data = { show_price: value.toString() };
    dispatch(updateSettings(data)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Setting updated successfully!");
        dispatch(getSettings());
      } else {
        toast.error("Failed to update setting");
      }
    });
  };

  const handleAddSchemeName = () => {
    const trimmed = newSchemeName.trim();
    if (!trimmed) {
      toast.error("Enter a scheme name");
      return;
    }
    if (localSchemeNames.includes(trimmed)) {
      toast.error("Scheme name already exists");
      return;
    }
    setLocalSchemeNames([...localSchemeNames, trimmed]);
    setNewSchemeName("");
  };

  const handleRemoveSchemeName = (name) => {
    setLocalSchemeNames(localSchemeNames.filter((item) => item !== name));
  };

  const handleSaveSchemeNames = () => {
    dispatch(updateSchemeNames(localSchemeNames)).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Scheme names saved successfully!");
        dispatch(getSchemeNames());
      } else {
        toast.error("Failed to save scheme names");
      }
    });
  };

  return (
    <div>
      <h3 className="mb-4 title">General Settings</h3>

      <div className="bg-white p-4 rounded-3 mb-4">
        <div className="d-flex align-items-center gap-4">
          <h5 className="mb-0">Show Product Prices Globally:</h5>
          <div className="d-flex gap-3">
            <button
              className={`btn ${showPrice ? "btn-success" : "btn-outline-success"}`}
              onClick={() => handleToggle(true)}
              disabled={isLoading}
            >
              ON
            </button>
            <button
              className={`btn ${!showPrice ? "btn-danger" : "btn-outline-danger"}`}
              onClick={() => handleToggle(false)}
              disabled={isLoading}
            >
              OFF
            </button>
          </div>
        </div>
        <p className="mt-3 text-muted mb-0">
          When turned OFF, prices will be hidden for all products across the website.
        </p>
      </div>

      <div className="bg-white p-4 rounded-3">
        <h5 className="mb-3">Gold Scheme Names</h5>
        <p className="text-muted">
          These names appear in the dropdown when adding 11+1 / Gold Scheme customers.
        </p>

        <div className="d-flex gap-2 mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="e.g. 11+1 Gold Scheme"
            value={newSchemeName}
            onChange={(e) => setNewSchemeName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), handleAddSchemeName())}
          />
          <button
            type="button"
            className="btn btn-outline-success"
            onClick={handleAddSchemeName}
          >
            Add
          </button>
        </div>

        {localSchemeNames.length > 0 ? (
          <ul className="list-group mb-3">
            {localSchemeNames.map((name) => (
              <li
                key={name}
                className="list-group-item d-flex justify-content-between align-items-center"
              >
                {name}
                <button
                  type="button"
                  className="btn btn-sm btn-outline-danger"
                  onClick={() => handleRemoveSchemeName(name)}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-muted">No scheme names added yet.</p>
        )}

        <button
          type="button"
          className="btn btn-success border-0 rounded-3"
          onClick={handleSaveSchemeNames}
        >
          Save Scheme Names
        </button>
      </div>
    </div>
  );
};

export default GeneralSettings;
